import React from "react";
import "./About.css";

function About() {
  return (
    <section id="about" className="about section">
      <div className="container">
        <p className="section-kicker">HIA Technologie Group</p>
        <h3 className="section-title">Le conseil informatique, au cœur de vos projets.</h3>
        <p className="about-text">
          HIA Technologie Group est spécialisé dans le conseil en systèmes et logiciels
          informatiques. Nous vous aidons à mieux comprendre vos besoins numériques et à
          identifier des solutions adaptées à votre activité, avec une approche attentive
          à votre organisation, à vos usages et à vos objectifs.
        </p>
        <div className="approach-grid">
          <article className="approach-item">
            <span>01</span>
            <h4>Écouter</h4>
            <p>Comprendre votre demande, vos contraintes et les résultats que vous recherchez.</p>
          </article>
          <article className="approach-item">
            <span>02</span>
            <h4>Analyser</h4>
            <p>Prendre en compte votre environnement et vos outils informatiques actuels.</p>
          </article>
          <article className="approach-item">
            <span>03</span>
            <h4>Conseiller</h4>
            <p>Vous aider à comparer les options et à choisir une direction adaptée.</p>
          </article>
        </div>
      </div>
    </section>
  );
}

export default About;
